export const htmlTagRegex = /<[^>]*?(?:\\<|\\>|[^<>\\])*>/g;
export const translationTagRegex = /\{%\s*translation\s+(.*?)\s*%\}([\s\S]*?)\{%\s*endtranslation\s*%\}/g;
// This is the same regex as above, but without the global flag `g`.
// We use this regex instead of the global one when we only want to find a single match.
// https://stackoverflow.com/questions/1520800/why-does-a-regexp-with-global-flag-give-wrong-results
export const singleTranslationTagRegex = /\{%\s*translation\s+(.*?)\s*%\}([\s\S]*?)\{%\s*endtranslation\s*%\}/;

export const getNextTranslationId = (inputString: string): string => {
  const idArray = inputString
    .split("{% translation id_")
    .filter((_str, index) => index !== 0)
    .map((str) => str.split("%}")[0]);

  if (!idArray.length) {
    return "id_1";
  }

  const highestId = idArray.reduce((maxId, currentId) => {
    return Math.max(Number(currentId), maxId);
  }, 0);

  return `id_${highestId + 1}`;
};

/**
 * @param {string} editorText: Text to find ranges from
 * @param {RegExp} regex: Regex to search for to build ranges
 * @returns {[number, number][]} List of number tuples containing the indices
 * within editorText where the regex matches
 */
export const getRegexTagRanges = (editorText: string, regex: RegExp): [number, number][] => {
  const tagRanges: [number, number][] = [];

  let match: RegExpExecArray | null;
  while ((match = regex.exec(editorText)) !== null) {
    const startIndex = match.index;
    const endIndex = startIndex + match[0].length;
    tagRanges.push([startIndex, endIndex]);
  }
  return tagRanges;
};

export const isRangeWithinExistingRanges = (
  newRange: [number, number],
  existingRanges: [number, number][]
): boolean => {
  return existingRanges.some(([start, end]) => newRange[0] < end && newRange[1] > start);
};
